import { LegendPayload } from 'recharts/types/component/DefaultLegendContent'
import { Payload as DefaultTooltipPayload } from 'recharts/types/component/DefaultTooltipContent'
import { NyuSeriesProperties } from '../../../shared/types'
import { resolveSeriesKey } from '../utils/helpers'
import useGetLineData from './useGetLineData'

export type TooltipPayloads = DefaultTooltipPayload<number, string>[]

export type LegendPayloads = LegendPayload[]

export type Payloads = TooltipPayloads | LegendPayloads

function preferNonForecastDataKeys(
    dataKeys: string[],
    seriesProperties: NyuSeriesProperties
) {
    return dataKeys.filter((dataKey) => {
        const seriesKey = resolveSeriesKey(dataKey, seriesProperties)
        return seriesKey === dataKey || !dataKeys.includes(seriesKey)
    })
}

export default function useChartPayload({
    payload,
    seriesProperties,
}: {
    payload: Payloads
    seriesProperties: NyuSeriesProperties
}) {
    const allDataKeys = [
        ...new Set(payload.flatMap(({ dataKey }) => String(dataKey))),
    ]

    const dataKeys = preferNonForecastDataKeys(allDataKeys, seriesProperties)

    const getLineData = useGetLineData(seriesProperties)

    return {
        dataKeys,
        getLineData,
    }
}
